import { createContext, useContext } from "react";
import {
  Address,
  Alert,
  Bot,
  InsightMetric,
  InsightWidget,
  Project,
} from "@/types";

export interface MonitorState {
  currentAddress?: Address;
  setCurrentAddress(addr?: Address): void;
  currentProjectId: string;
  setCurrentProjectId(projectId: string): void;
  currentProject: Project | null;
  setCurrentProject(project?: Project): void;
  projects: Project[];
  currentBotId: string;
  setCurrentBotId(botId: string): void;
  currentAlertId: string;
  setCurrentAlertId(alertId: string): void;
  currentAddressId: string;
  setCurrentAddressId(addressId: string): void;
  isProjectLoading: boolean;
  setIsProjectLoading(loading: boolean): void;
  setProjects(projects: Project[]): void;
  botsData: Bot[];
  setBotsData(bots: Bot[]): void;
  isLoadingBotsData: boolean;
  alertsData: Alert[];
  setAlertsData(alerts: Alert[]): void;
  refetchNewAlertCount(): void;
  currentView: "bots" | "alerts" | "insights";
  setCurrentView(view: "bots" | "alerts" | "insights"): void;
  currentMobileView: "bots" | "project";
  setCurrentMobileView(view: "bots" | "project"): void;
  newAlertCount: number;
  currentInsightsLayout: InsightWidget[];
  setCurrentInsightsLayout(widgets: InsightWidget[]): void;
  metricData: InsightMetric[];
  setMetricData(param: InsightMetric[]): void;
  alertFrom: string;
  setAlertFrom(data: string): void;
  alertTo: string;
  setAlertTo(data: string): void;
  showOnlyAlertUnread: boolean;
  setShowOnlyAlertUnread(data: boolean): void;
  reset(): void;
}

export const monitorInitialState: MonitorState = {
  currentAddress: undefined,
  setCurrentAddress: () => {},
  projects: [],
  currentProjectId: "",
  setCurrentProjectId: () => {},
  currentBotId: "",
  setCurrentBotId: () => {},
  currentAlertId: "",
  setCurrentAlertId: () => {},
  currentAddressId: "",
  setCurrentAddressId: () => {},
  currentProject: null,
  setCurrentProject: () => {},
  setProjects: () => {},
  isLoadingBotsData: false,
  alertsData: [],
  setAlertsData: () => {},
  botsData: [],
  setBotsData: () => {},
  currentView: "bots",
  setCurrentView: () => {},
  currentMobileView: "project",
  setCurrentMobileView: () => {},
  isProjectLoading: false,
  setIsProjectLoading: () => {},
  refetchNewAlertCount: () => {},
  newAlertCount: 0,
  currentInsightsLayout: [],
  setCurrentInsightsLayout: () => {},
  metricData: [],
  setMetricData: () => {},
  alertFrom: "",
  setAlertFrom: () => {},
  alertTo: "",
  setAlertTo: () => {},
  showOnlyAlertUnread: false,
  setShowOnlyAlertUnread: () => {},
  reset: () => {},
};

export const MonitorContext = createContext<MonitorState>(monitorInitialState);

export const useMonitor = () => useContext(MonitorContext);
